import { css, keyframes } from 'styled-components';
import { getBaseTheme } from '@Themes';

const { texts, spaces, colors } = getBaseTheme();

const movingDown = keyframes`
  0% {
    transform: rotate(0) scale(1) translateX(0) translateY(0) skewX(0) skewY(0);
    transform-origin: 0 0;
    bottom: 0;
    opacity: 1;

  }
  100% {
    transform: rotate(0) scale(1) translateX(0) translateY(150%) skewX(0)
      skewY(0);
    transform-origin: 0 0;
    bottom: -70%;
    opacity: 0;
  }
}`;

const movingUp = keyframes`
  0% {
    transform: translateY(100px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
    bottom: 10px;
  }
}`;

export default css`
    width: 100%;
    position: ${prop => (prop.noposition === 'false' ? 'absolute' : '')};
    bottom: ${prop => (prop.noposition === 'false' ? '0.625rem' : '')};
    font-size: ${texts.sizes.m.fontSize};
    line-height: ${texts.sizes.m.lineHeight};
    color: ${colors.area.default.foregroundColor};
    span {
        display: block;
        margin: 0 ${spaces.default.s};
        text-align: center;
    }
    &.push-down {
        animation: ${movingDown};
        animation-duration: 1.8s;
        animation-timing-function: ease;
        animation-fill-mode: forwards;
    }

    &.push-up {
        animation: ${movingUp};
        animation-duration: 1s;
        animation-timing-function: ease;
        animation-fill-mode: forwards;
    }
`;
